<ng-container *ngIf="loaded; else loadingContent">
    <ng-container *ngTemplateOutlet="heroTemplate"></ng-container>
</ng-container>

<ng-template #loadingContent>
    <div class="container mt-4">
        <div class="row">
            <div class="col-lg-12">
                <ngx-skeleton height="470px"></ngx-skeleton>
            </div>
        </div>
    </div>
</ng-template>

<!-- TYPE 1: Banner de divulgação -->
<ng-template #banner>
    <div class="container">
        <div class="hero-container" *ngIf="sliders.length">
            <ngx-glide
                [perView]="1"
                [showBullets]="false"
                [arrowLeftTemplate]="arrowLeft"
                [arrowRightTemplate]="arrowRight"
                [touchAngle]="0"
                [autoplay]="6000"
                [dragThreshold]="false"
                [swipeThreshold]="false"
                #ngxGlide
            >
                <div class="hero hero-banner" *ngFor="let slide of sliders">
                    <a [routerLink]="['/news/', slide.url_amigavel]">
                        <div class="hero-content">
                            <h3 class="hero-title">{{ slide.title }}</h3>
                        </div>
                        <div class="hero-img">
                            <img [src]="slide.image" alt="slide.title" />
                        </div>
                    </a>
                </div>
            </ngx-glide>
        </div>
    </div>
</ng-template>

<!------------- TYPE 2: Carousel com overlay nas imagens ----------------->
<ng-template #carouselOverlay>
    <div class="hero-container" *ngIf="sliders.length">
        <ngx-glide
            [perView]="1"
            [showBullets]="false"
            [arrowLeftTemplate]="arrowLeft"
            [arrowRightTemplate]="arrowRight"
            [touchAngle]="0"
            [autoplay]="6000"
            [dragThreshold]="false"
            [swipeThreshold]="false"
            #ngxGlide
        >
            <div class="hero hero-overlay" *ngFor="let slide of sliders">
                <a [routerLink]="['/news/', slide.url_amigavel]">
                    <div class="hero-content">
                        <h3 class="hero-title">{{ slide.title }}</h3>
                        <hr class="hero-content-divider divider" />
                        <div class="hero-publisher">
                            <div class="d-flex align-items-center">
                                <p class="paragraph-2">Publicado por</p>
                                <img [src]="slide.author.url_avatar" width="24px" height="24px" />
                            </div>
                            <p class="paragraph-2">{{ slide.dt_post }}</p>
                        </div>
                    </div>
                    <div class="hero-img">
                        <img [src]="slide.image" alt="slide.title" />
                    </div>
                </a>
            </div>
        </ngx-glide>
    </div>
</ng-template>

<!------------- TYPE 3: Carousel sem overlay (imagem nítida) ----------------->
<ng-template #carousel>
    <div class="hero-container" *ngIf="sliders.length">
        <ngx-glide
            [perView]="1"
            [showBullets]="false"
            [arrowLeftTemplate]="arrowLeft"
            [arrowRightTemplate]="arrowRight"
            [autoplay]="6000"
            [touchAngle]="0"
            [dragThreshold]="false"
            [swipeThreshold]="false"
            #ngxGlide
        >
            <div class="hero hero-sharp" *ngFor="let slide of sliders">
                <a [routerLink]="['/news/', slide.url_amigavel]">
                    <div class="hero-content">
                        <h3 class="hero-title">{{ slide.title }}</h3>
                        <hr class="hero-content-divider divider" />
                        <div class="hero-publisher">
                            <div class="d-flex align-items-center">
                                <p class="paragraph-2">Publicado por</p>
                                <img [src]="slide.author.url_avatar" width="24px" height="24px" />
                            </div>
                            <p class="paragraph-2">{{ slide.dt_post }}</p>
                        </div>
                    </div>
                    <div class="hero-img">
                        <img [src]="slide.image" alt="slide.title" />
                    </div>
                </a>
            </div>
        </ngx-glide>
    </div>
</ng-template>

<ng-template #arrowLeft>
    <button nbButton class="slide-arrow slide-arrow--left"><nb-icon icon="arrow-ios-back-outline"></nb-icon></button>
</ng-template>
<ng-template #arrowRight>
    <button nbButton class="slide-arrow slide-arrow--right">
        <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
    </button>
</ng-template>
